import configJsInstance from './instance'

const getConfigJsData = (timestamp) => {
	return configJsInstance.get(`/config.js?version=${timestamp}`)
}

export default getConfigJsData
